var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownCloseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0853 0.61567C3.28348 0.32144 3.71651 0.32144 3.9147 0.61567L6.00615 3.72067C6.22985 4.05278 5.99188 4.5 5.59145 4.5L1.40855 4.5C1.00812 4.5 0.770151 4.05278 0.993851 3.72067L3.0853 0.61567Z",
    fill: "#09414E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownCloseArrow);
export default __webpack_public_path__ + "static/media/dropdown-close-arrow.876a88a1bff9b442f43e02309bc5c64e.svg";
export { ForwardRef as ReactComponent };